import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Label,
  Modal, ModalHeader, ModalBody,
  CardFooter,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransferTypes, fetchCategory, fetchDesignation, fetchDepartment, fetchReporting, fetchEmployeeListtoTransfer,saveEmployeeTransfer,fetchTransferLog } from "store/actions";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
let data = [];

const EmployeeMassTransfer = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
  const {
    transfer_type,
    categoryList,
    designationList,
    departmentList,
    reportList,
    employeeList,
    transferLogs,
    clearList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    transfer_type: state.EmployeeDetailsReducer?.transfer_type ?? [],
    categoryList: state.EmployeeDetailsReducer?.categoryList ?? [],
    designationList: state.EmployeeDetailsReducer?.designationList ?? [],
    departmentList: state.EmployeeDetailsReducer?.departmentList ?? [],
    reportList: state.EmployeeDetailsReducer?.reportList ?? [],
    employeeList: state.EmployeeDetailsReducer?.employeeList ?? [],
    transferLogs: state.EmployeeDetailsReducer?.transferLogs ?? [],
    clearList: state.EmployeeDetailsReducer?.clearList ?? [],
    loading: state.EmployeeDetailsReducer?.loading,
    error: state.EmployeeDetailsReducer?.error || state.DepartmentMaster?.error,
    success: state.EmployeeDetailsReducer?.success,
  }));
  const [authDetails, setAuthDetails] = useState(null);
  const [viewLogModal, setViewLogModal] = useState(false);
  const [Type, setSelectedValue] = useState([]);
  const [formikkk, setSelectedFormik] = useState([]);
  const dispatch = useDispatch();
  const authUserDetails = useAuthUserDetails();
  const [selecteddata, setSelectedData] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const alphaNumSpecial200Regex = /^[A-Za-z0-9\\s.,\-/#()|]+$/;

  useEffect(() => {
    if (success) {
      handleReset();
    }

  }, [success])


const handleReset = () => {
  showFormik.resetForm();
  transferFormik.resetForm();
  setSelectedData([]);
  setData([]);
};

  const handleCancel = async (e) => {
    e.preventDefault();

    // check if anything actually changed
    const hasChanges =
      showFormik.dirty ||
      transferFormik.dirty ||
      selectedRows.length > 0 ||
      data.length > 0;

    // if nothing changed → silent reset
    if (!hasChanges) {
      handleReset();
      return;
    }

    const result = await Swal.fire({
      title: "Confirm Cancel",
      text: "All entered data will be cleared. Do you want to continue?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      confirmButtonColor: "rgb(145, 73, 234)",
      cancelButtonColor: "#6c757d",
    });

    if (!result.isConfirmed) return;

    handleReset();
  };


  const typeOptions = transfer_type.map(item => ({ label: item.transfer_type, value: item.type_id }));

  // data = employeeList.map(emp => ({
  //   sno: 1,
  //   emp_id: emp.emp_id,
  //   code: emp.emp_no,
  //   name: emp.emp_name,
  //   category: emp.category,
  //   designation: emp.designation,
  //   department: emp.department
  // }));

  useEffect(() => {
  if (employeeList && employeeList.length > 0) {
      const data = employeeList.map((emp, index) => ({
        sno: index + 1,
        emp_id: emp.emp_id,
        code: emp.emp_no,
        name: emp.emp_name,
        category: emp.category,
        designation: emp.designation,
        department: emp.department
      }));

      setData(data);
    }
  }, [employeeList]);

  // Formik for Show form
  const showFormik = useFormik({
    initialValues: { type: "", categoryFrom: "", },
    validationSchema: Yup.object({ type: Yup.string().nullable().required("Type is required"), categoryFrom: Yup.string().nullable().required("Category From is required"), }),

    onSubmit: (values) => {
      const authUserDetails = useAuthUserDetails();
      const formData = new FormData();
      formData.append("unit_id", authUserDetails[0].unit_id);
      formData.append("type_id", values.type);
      formData.append("id", values.categoryFrom);
      dispatch(fetchEmployeeListtoTransfer(formData));
      setSelectedFormik(values.categoryFrom);
    },
  });


  const columns = [
    { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
    { Header: "Emp Code", accessor: "code" },
    { Header: "Name", accessor: "name" },
    { Header: "Category", accessor: "category" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Department", accessor: "department" },
     {
      id: "selection",
      className: "serial-no text-center",
      Header: ({ getToggleAllPageRowsSelectedProps }) => (
        <input
          type="checkbox"
          {...getToggleAllPageRowsSelectedProps()}
        />
      ),
      Cell: ({ row }) => (
        <input
          type="checkbox"
          {...row.getToggleRowSelectedProps()}
        />
      ),
    },

  ];

  const handleSelectedRowsChange = React.useCallback((rows) => {
    setSelectedRows(rows);
  }, []);

  const handleOptionChange = (e, row1) => {
    const isChecked = e.target.checked;
    const emp_id = row1.original.emp_id;

    setSelectedData((prev) => {
      if (isChecked) {
        // add if not already added
        if (!prev.some(item => item.emp_id === emp_id)) {
          return [...prev, { emp_id }];
        }
        return prev;
      } else {
        // remove when unchecked
        return prev.filter(item => item.emp_id !== emp_id);
      }
    });
  };

  const handleTypeChange = (selectedType) => {
    const authUserDetails = useAuthUserDetails();
    if (!selectedType) {
      setSelectedValue(null);
      return;
    }
    setSelectedValue(selectedType.value);
    if (selectedType.value === "1") {
      dispatch(fetchCategory(authUserDetails[0].unit_id));
    } else if (selectedType.value === "2") {
      dispatch(fetchDepartment(authUserDetails[0].unit_id));
    } else if (selectedType.value === "3") {
      dispatch(fetchDesignation(authUserDetails[0].unit_id));
    } else if (selectedType.value === "4") {
      dispatch(fetchReporting(authUserDetails[0].unit_id));
    }
  };

  const getTransferLogs = () => {
    dispatch(fetchTransferLog(authUserDetails[0].unit_id));
    setViewLogModal(true);
  };

  let categoryOptions = []
  if (Type === "1") {
    categoryOptions = categoryList.map(item => ({ label: item.empCategory, value: item.empCatgryid }));
  } else if (Type === "3") {
    categoryOptions = designationList.map(item => ({ label: item.designation, value: item.desig_id }));
  } else if (Type === "2") {
    categoryOptions = departmentList.map(item => ({ label: item.departmentcode, value: item.departmentId })); //reportList
  } else if (Type === "4") {
    categoryOptions = reportList.map(item => ({ label: item.report_name, value: item.report_id })); //reportList
  }

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    dispatch(fetchTransferTypes(authUserDetails[0].unit_id));
  }, []);

  // Formik for Transfer form
  const transferFormik = useFormik({
    initialValues: { categoryTo: null, effectiveDate: null, reason: "", },
    validationSchema: Yup.object({
      categoryTo: Yup.string().nullable().required("Category To is required"),
      effectiveDate: Yup.date().nullable().required("Effective Date is required"),
      reason: Yup.string()
        .required("Reason is required")
        .max(200, "Reason must not exceed 200 characters")
        .matches(
          alphaNumSpecial200Regex,
          "Only alphabets, numerics and special characters are allowed"
        ),
    }),

    onSubmit: (values) => {      
      const selecteddata = selectedRows.map(row => ({
        emp_id: row.emp_id,
      }));
      if (selecteddata.length === 0) {
        Swal.fire({ icon: "warning", title: "No Selection", text: "Please select at least one before proceeding.", });
        return;
      }

      if (formikkk === values.categoryTo) {
        Swal.fire({ icon: "warning", title: "Identical", text: "Please select different category.", });
        return;
      }

      let result = { trans: selecteddata };
      const formData = new FormData();
      formData.append("lst_employee_Transfer", JSON.stringify(result));
      formData.append("create_by", authDetails?.user_id);
      formData.append("type_id", Type);
      formData.append("from_id", formikkk);
      formData.append("to_id", values.categoryTo);
      formData.append("effect_date", values.effectiveDate);
      formData.append("reason", values.reason);

      dispatch(saveEmployeeTransfer(formData))
    },
  });

  // modal data
  let logData = [];
  logData = transferLogs.map(emp => ({
    sno: 1,
    emp_no: emp.emp_no,
    emp_name: emp.emp_name,
    transfer_type: emp.transfer_type,
    old_category: emp.old_category,
    new_category: emp.new_category,
    reason: emp.reason,
    effect_dt: emp.effect_dt,
    created_by: emp.created_by,
    created_dt: emp.created_dt
  }));

  const logColumns = [
    { Header: "S No", Cell: ({ row }) => logData.length - row.index, className: "serial-no text-center", },
    { Header: "Emp Code", accessor: "emp_no" },
    { Header: "Emp Name", accessor: "emp_name" },
    { Header: "Transfer Type", accessor: "transfer_type" },
    { Header: "Transfer From", accessor: "old_category" },
    { Header: "Transfer To", accessor: "new_category" },
    { Header: "Reason", accessor: "reason" },
    { Header: "Effective Date", accessor: "effect_dt" },  
    { Header: "Created On", accessor: "created_dt" },  
    { Header: "Created By", accessor: "created_by" },  
  ];

  return (
    <div className="page-content">
      {/* <Loader loading={loading} /> */}
      <Container fluid>
        <Breadcrumbs title="Employee" breadcrumbItem="Employee Mass Transfer" />

        {/* Show Form */}
        <Card>
          <CardBody>
            <form onSubmit={showFormik.handleSubmit}> 
               {/* onSubmit={showFormik.handleSubmit} */}
              <Row className="gy-3">
                <Col xl={4} md={6}>
                  <Label>Transfer Type <span className="text-danger">*</span></Label>
                  <CustomSelect
                    name="type"
                    value={typeOptions.find(opt => opt.value === showFormik.values.type) || null}
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        showFormik.setFieldValue("type", selectedOption?.value); // store only the string
                      } else {
                        showFormik.setFieldValue("type", null); // or "" if needed
                      }
                      setSelectedData([]);
                      setData([]);
                      handleTypeChange(selectedOption);
                    }}
                    options={typeOptions}
                    // placeholder="--Select--"
                  />
                  {showFormik.touched.type && showFormik.errors.type && (
                    <div className="text-danger">{showFormik.errors.type}</div>
                  )}
                </Col>
                <Col xl={4} md={6}>
                  <Label>Transfer From <span className="text-danger">*</span></Label>
                  <CustomSelect
                    name="categoryFrom"
                    value={categoryOptions.find(opt => opt.value === showFormik.values.categoryFrom) || null}
                    onChange={(val) => {
                      if (val) {
                        showFormik.setFieldValue("categoryFrom", val.value); // store only the string
                      } else {
                        showFormik.setFieldValue("categoryFrom", null); // or "" if needed
                      }
                      setData([]);
                      setSelectedData([]);
                    }}
                   
                    options={categoryOptions}
                    // placeholder="--Select--"
                  />
                  {showFormik.touched.categoryFrom && showFormik.errors.categoryFrom && (
                    <div className="text-danger">{showFormik.errors.categoryFrom}</div>
                  )}
                </Col>
                <Col className="d-flex align-items-center justify-content-end mob-center">
                  {/* <Button type="submit" className="btn button-search me-2"><i className="fas fa-search me-1" /> Search</Button>
                  <Button type="button" className="btn button-edit" onClick={() => getTransferLogs()}><i className="fas fa-eye me-1" /> View Log</Button> */}
                  {/* SEARCH — visible for View, Edit, Create */}
                  {(canRead || canEdit || canCreate) && (
                    <Button type="submit" className="btn button-search me-2">
                      <i className="fas fa-search me-1" /> Search
                    </Button>
                  )}

                  {/* VIEW LOG — visible for View, Edit, Create */}
                  {(canRead || canEdit || canCreate) && (
                    <Button type="button" className="btn button-edit me-2" onClick={getTransferLogs}>
                      <i className="fas fa-eye me-1" /> View Log
                    </Button>
                  )}
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        {/* Table */}
        <Card>
          
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              onSelectedRowsChange={handleSelectedRowsChange}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
          <CardFooter className="border-bottom pb-3">
            <form onSubmit={transferFormik.handleSubmit}>
              <Row className="gy-3">
                <Col md={3}>
                  <Label>Transfer To <span className="text-danger">*</span></Label>                 

                  <CustomSelect
                    name="categoryTo"
                    value={categoryOptions.find(opt => opt.value === transferFormik.values.categoryTo) || null}
                    onChange={(val) => {
                      if (val) {
                        transferFormik.setFieldValue("categoryTo", val.value); // store only the string
                      } else {
                        transferFormik.setFieldValue("categoryTo", null); // or "" if needed
                      }
                    }}
                    options={categoryOptions}
                    // placeholder="--Select--"
                  />
                  {transferFormik.touched.categoryTo && transferFormik.errors.categoryTo && (
                    <div className="text-danger">{transferFormik.errors.categoryTo}</div>
                  )}
                </Col>
                <Col md={3}>
                  <Label>Effective Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="effectiveDate"
                    value={transferFormik.values.effectiveDate || null}
                    selected={transferFormik.values.effectiveDate}
                    onChange={date => transferFormik.setFieldValue("effectiveDate", date || null)}
                    onBlur={() => transferFormik.setFieldTouched("effectiveDate", true)}
                  />
                  {transferFormik.touched.effectiveDate && transferFormik.errors.effectiveDate && (
                    <div className="text-danger">{transferFormik.errors.effectiveDate}</div>
                  )}
                </Col>
                <Col md={3}>
                  <Label>Reason <span className="text-danger">*</span></Label>
                  <textarea
                    name="reason"
                    value={transferFormik.values.reason || ""}
                    onChange={transferFormik.handleChange}
                    onBlur={transferFormik.handleBlur}
                    maxLength={200}
                    className="form-control"
                    style={{ height: "33.1px" }}
                  />
                  {transferFormik.touched.reason && transferFormik.errors.reason && (
                    <div className="text-danger">{transferFormik.errors.reason}</div>
                  )}
                </Col>
                <Col className="d-flex align-items-center justify-content-end">
                  {/* <Button type="submit" className="btn button-save me-2"><i className="fas fa-exchange-alt me-1" /> Transfer</Button>
                  <Button type="reset" className="btn button-cancel" onClick={handleReset}><i className="fas fa-sync me-1" /> Cancel</Button> */}
                  {/* TRANSFER — visible only for Edit or Create */}
                  {(canEdit || canCreate) && (
                    <Button type="submit" className="btn button-save me-2">
                      <i className="fas fa-exchange-alt me-1" /> Transfer
                    </Button>
                  )}

                  {/* CANCEL — visible for View, Edit, Create */}
                  {(canRead || canEdit || canCreate) && (
                    <Button type="button" className="btn button-cancel" onClick={handleCancel}>
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  )}
                </Col>
              </Row>
            </form>
          </CardFooter>
        </Card>


        {/* View Log Modal */}
        <Modal isOpen={viewLogModal} toggle={() => setViewLogModal(!viewLogModal)} size="xl" className="modalborder-0">
          <ModalHeader toggle={() => setViewLogModal(!viewLogModal)} className="card-main-title bg-grey"><h6 className="title text-black">Transfer Log Details</h6></ModalHeader>
          <ModalBody>
            <TableContainer
              columns={logColumns}
              data={logData}
              isGlobalFilter={false}
              customPageSize={10}
              tableSorter={false}
            />
          </ModalBody>
        </Modal>

      </Container>
    </div>
  );
};

export default EmployeeMassTransfer;